import {useEffect, useState} from "react";
import {Spin} from "antd";
import App from "./App";
import {keycloack} from "./common/keycloack";
import FetchUserInfo from "./FetchUserInfo";


export default function CheckLogin(props) {
    const [authenticated, setAuthenticated] = useState(false);
    useEffect(() => {
        keycloack()
            .then(() => setAuthenticated(true))
    }, []);

    return authenticated ? <FetchUserInfo>{props.children}</FetchUserInfo> : <Spin spinning={true}/>
}
